export {
  Tag,
  TagCloseButton,
  TagLabel,
  TagLeftIcon,
  TagRightIcon
} from '@chakra-ui/react';
export type {
  TagCloseButtonProps,
  TagLabelProps,
  TagProps
} from '@chakra-ui/react';
